import { getKeys } from '.';

export function getSearchParams() {
    const search = window.location.search || '';
    const queryString = search.split('?')[1] || '';
    return new URLSearchParams(queryString);
}

/**
 * Convert a `URLSearchParams` instance to a plain key:value pair JavaScript object.
 */
export function searchParamsToObject(params: URLSearchParams) {
    return Array.from(params.entries()).reduce(
        (params, [key, value]) => {
            params[key] = value;
            return params;
        },
        {} as Record<string, string>
    );
}

export function buildQuery(params: Record<string, unknown>) {
    return getKeys(params)
        .map(k => `${encodeURIComponent(k)}=${encodeURIComponent(params[k] + '')}`)
        .join('&');
}
